import { ComponentProps, CSSProperties, FC, PropsWithChildren } from "react";
import { useEnrollmentContext } from "@/state";

type ThemedTitleProps = ComponentProps<"h1">;

export const ThemedTitle: FC<PropsWithChildren<ThemedTitleProps>> = (props) => {
  const { children, style, ...headingProps } = props;
  const experienceData = useEnrollmentContext();
  const font = (experienceData?.theme as { font?: string } | undefined)?.font || "Source Sans 3";

  const themedStyle: CSSProperties = {
    fontFamily: font,
    fontWeight: 400,
    fontSize: "24px",
    ...(style || {}),
  };

  return <h1 {...headingProps} style={themedStyle}>{children}</h1>;
};
